import React from "react";
import Title from "../../../components/Title/Title";
import './RegistrationPage.scss';

const Registration2026page = () => {
    return (
        <div>
            <Title>Venue and Registration</Title>
            <h5>Venue</h5>
            <p>CLeaR 2026 is held in Cambridge, MA, United States, hosted by the Broad Institute of MIT and Harvard, on Apr 6-8, 2026.
            </p>
            <h5>Registration</h5>
            {/* <p>You can register for the in-person attendance at CLeaR 2026 <a href="https://broadinstitute.swoogo.com/2026clear"><b>through this portal</b></a> (Early Bird pricing available until <s>Mar 11</s> Mar 14 11:30pm EDT).</p>
            <p>We also offer virtual attendance, and the application can be filled <a href="https://docs.google.com/forms/d/e/1FAIpQLSczCUkEfu2jgsH6VDJbKLwG722vsWRx80kFaLwEThoArRRidw/viewform?usp=header"><b>through this form</b></a>.
            </p> */}
            <p>Registration for CLeaR 2026 is closed.</p>
            <h5>Contact</h5>
            <p>If there is any question, please contact the program chairs at <a href="mailto:clear.chairs26@gmail.com">clear.chairs26@gmail.com</a>.</p>
        </div>
    )
}

export default Registration2026page

